import type { NavDict } from '../en/nav';

export const nav: NavDict = {
  groups: {
    userFacing: 'För användare',
    admin: 'Admin',
    qagent: 'QAgent',
    projects: 'Projekt',
    quickChats: 'Snabbchattar',
  },
  items: {
    meetings: 'Möten',
    playbooks: 'Playbooks',
    users: 'Användare',
    organizations: 'Organisationer',
    trialUsers: 'Testanvändare',
    features: 'Funktioner',
    fileSearchStores: 'Fildatabaser',
    usage: 'Användning',
    feedbackResponses: 'Feedbacksvar',
    modelSettings: 'Modellinställningar',
    newChat: 'Ny chatt',
    newContract: 'Nytt avtal',
    feedback: 'Feedback',
    installForWord: 'Installera för Word',
  },
  tooltips: {
    startBlankChat: 'Starta en tom chatt',
    draftNewContract: 'Skapa ett nytt avtal från grunden',
    createNewProject: 'Skapa nytt projekt',
  },
  projects: {
    none: 'Inga projekt än',
    createToOrganize: 'Skapa ett för att organisera ditt arbete',
  },
  share: {
    menu: 'Dela…',
    title: (project: string) => `Dela "${project}"`,
    onlyMe: 'Bara jag',
    onlyMeHint: 'Ingen annan kan öppna projektet.',
    organization: (org: string) => `Alla i ${org}`,
    organizationHint: 'Alla medlemmar kan öppna projektet.',
    people: 'Utvalda personer',
    peopleHint: 'Bara de personer du lägger till kan öppna projektet.',
    canEdit: 'Kan redigera',
    canView: 'Kan visa',
    canEditHint: 'Ladda upp och ta bort filer, koppla playbooks',
    canViewHint: 'Läsa filer och starta egna chattar',
    addPerson: 'Lägg till en person',
    searchPlaceholder: 'Sök på namn eller e-post',
    noMatches: 'Inga matchande medlemmar',
    nobodyYet: 'Ingen tillagd ännu.',
    remove: 'Ta bort',
    save: 'Spara',
    cancel: 'Avbryt',
    saved: 'Delningen har uppdaterats',
    failed: 'Det gick inte att uppdatera delningen',
    sharedBy: (name: string) => `Delat av ${name}`,
    sharedIcon: 'Delat',
    yourOrganization: 'er organisation',
    chatsStayPrivate: 'Chattar förblir privata: var och en ser bara sina egna chattar i projektet.',
  },
  chats: {
    rename: 'Byt namn',
    renameTitle: 'Byt namn på chatten',
    save: 'Spara',
    cancel: 'Avbryt',
    newInProject: 'Ny chatt i projektet',
    renameFailed: 'Det gick inte att byta namn på chatten',
    none: 'Inga senaste chattar',
    startAbove: 'Starta en konversation ovan',
    untitled: 'Namnlös chatt',
    newChat: 'Ny chatt',
    fromEmail: 'Från e-post',
  },
  poweredBy: 'Drivs av',
  user: {
    fallbackName: 'Användare',
    fallbackEmail: 'user@example.com',
  },
  newProjectDialog: {
    title: 'Skapa nytt projekt',
    description:
      'Skapa ett nytt projekt för att organisera dina dokument och konversationer.',
    nameLabel: 'Projektnamn',
    namePlaceholder: 't.ex. Acme Corp NDA-granskning',
    trialUsage: (used: number) =>
      `Gratis testperiod: ${used} av 2 projekt använda.`,
    creating: 'Skapar …',
    submit: 'Skapa projekt',
    createFailed: 'Det gick inte att skapa projektet',
  },
  deleteProjectDialog: {
    title: 'Radera projekt',
    description: (name: string) =>
      `Är du säker på att du vill radera ”${name}”? Detta tar permanent bort projektet och alla dess filer.`,
    deleting: 'Raderar …',
    confirm: 'Radera',
  },
};
